var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 0.5H2C1.17275 0.5 0.5 1.17275 0.5 2V7.25C0.5 8.07725 1.17275 8.75 2 8.75H5.75C6.57725 8.75 7.25 8.07725 7.25 7.25V2C7.25 1.17275 6.57725 0.5 5.75 0.5ZM14 0.5H10.25C9.42275 0.5 8.75 1.17275 8.75 2V4.25C8.75 5.07725 9.42275 5.75 10.25 5.75H14C14.8273 5.75 15.5 5.07725 15.5 4.25V2C15.5 1.17275 14.8273 0.5 14 0.5ZM5.75 10.25H2C1.17275 10.25 0.5 10.9227 0.5 11.75V14C0.5 14.8273 1.17275 15.5 2 15.5H5.75C6.57725 15.5 7.25 14.8273 7.25 14V11.75C7.25 10.9227 6.57725 10.25 5.75 10.25ZM14 7.25H10.25C9.42275 7.25 8.75 7.92275 8.75 8.75V14C8.75 14.8273 9.42275 15.5 10.25 15.5H14C14.8273 15.5 15.5 14.8273 15.5 14V8.75C15.5 7.92275 14.8273 7.25 14 7.25Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard_icon.43a727f9330c1e1acf94adf50d1cabea.svg";
export { ForwardRef as ReactComponent };